import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const CompanyIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 16 18">
        <path
            d="M5.66667 17V9H10.3333V17M1 6.6L8 1L15 6.6V15.4C15 15.8243 14.8361 16.2313 14.5444 16.5314C14.2527 16.8314 13.857 17 13.4444 17H2.55556C2.143 17 1.74733 16.8314 1.45561 16.5314C1.16389 16.2313 1 15.8243 1 15.4V6.6Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
